import {decorate, injectable} from 'inversify';
import {ExperimentBag} from '../../experiments/ExperimentBag';
import {conductExperiments} from '../../experiments/experiments';
import {IExperimentsApi} from './IExperimentsApi';

export class ExperimentsApi implements IExperimentsApi {
  getExperiments(scope: string) {
    return conductExperiments(scope) as Promise<ExperimentBag>;
  }
}
decorate(injectable(), ExperimentsApi);
